const Vue = require("vue");
import moment from "moment-jalaali";

// hotel booking components
import Destination from "./Components/Destination.vue";
import Datepicker from "./Components/Datepicker.vue";
import Departure from "./Components/Departure.vue";
import Nationality from "./Components/Nationality.vue";
import Travellers from "./Components/Travellers.vue";
import HotelItems from "./Components/HotelItems.vue";

import { showAlert } from "../../../Helpers/tools";

// create vue element for hotel booking
if (document.getElementById("js-hotel-booking")) {
  let destinationType = document
    .getElementById("js-hotel-booking")
    .getAttribute("destinationType");

  var vmHotel = new Vue({
    el: "#js-hotel-booking",

    components: {
      Destination,
      Departure,
      Datepicker,
      Nationality,
      Travellers,
      HotelItems,
    },

    computed: {
      locale() {
        return this.isJalali ? "fa,en" : "en,fa";
      },

      format() {
        return this.isJalali ? "jYYYY/jM/jD" : "D MMM YYYY";
      },
    },

    data() {
      return {
        isJalali: true,

        destinationType: Number(destinationType),

        exitDateMin: moment(Date().now).format("jYYYY/jMM/jDD"),

        baseUrl: "/fa/hotel/",

        isLoaded: false,
      };
    },

    methods: {
      // fill next input
      fillNextInput() {
        let timeOut;

        let destination = this.$refs.destination;

        let entryDate = this.$refs.entryDate;

        let exitDate = this.$refs.exitDate;

        if (!destination.selectedHotel) {
          timeOut = setTimeout(() => {
            destination.showDefaultHotels();
            clearTimeout(timeOut);
          }, 50);

          return;
        }

        if (!entryDate.date) {
          timeOut = setTimeout(() => {
            entryDate.$refs.datepicker.focus();
            clearTimeout(timeOut);
          }, 50);

          return;
        }

        if (!exitDate.date) {
          timeOut = setTimeout(() => {
            exitDate.$refs.datepicker.focus();
            clearTimeout(timeOut);
          }, 50);

          return;
        }
      },

      // change hotel destination type
      changeDestinationType(type) {
        this.destinationType = type;
        let destination = this.$refs.destination;

        destination.defaultList = [];
        destination.hotelsList = [];

        destination.inputValue = "";
        destination.selectedHotel = false;
      },

      // change datepicker locale
      changeLocale(type) {
        if (type === "fa,en") {
          this.isJalali = true;
        } else {
          this.isJalali = false;
        }
      },

      // get date from entryDate and set to exitDate min
      dateChanged(event) {
        this.exitDateMin = moment(event).format("jYYYY/jMM/jDD");
        this.$refs.exitDate.date = "";
      },

      // check input is valid
      checkValidation() {
        let valid = true;

        let destination = this.$refs.destination;

        let nationality = this.$refs.nationality;

        let entryDate = this.$refs.entryDate.date
          ? moment(this.$refs.entryDate.date, "jYYYY/jMM/jDD")
              .locale("en")
              .format("YYYY/MM/DD")
          : "";

        let exitDate = this.$refs.exitDate.date
          ? moment(this.$refs.exitDate.date, "jYYYY/jMM/jDD")
              .locale("en")
              .format("YYYY/MM/DD")
          : "";

        if (!destination.selectedHotel) {
          showAlert([
            {
              type: 8,
              message: "مقصد را انتخاب کنید",
            },
          ]);

          valid = false;
        }

        if (this.destinationType === 1) {
          if (!nationality.nationalityCode) {
            showAlert([
              {
                type: 8,
                message: "ملیت خود را انتخاب کنید",
              },
            ]);

            valid = false;
          }
        }

        if (!entryDate) {
          showAlert([
            {
              type: 8,
              message: "تاریخ ورود را انتخاب کنید",
            },
          ]);

          valid = false;
        }

        if (!exitDate) {
          showAlert([
            {
              type: 8,
              message: "تاریخ خروج را انختاب کنید",
            },
          ]);

          valid = false;
        }

        let dateDifference = moment(exitDate, "YYYY/M/D").diff(
          moment(entryDate, "YYYY/M/D"),
          "days"
        );

        if (dateDifference > 20) {
          showAlert([
            {
              type: 8,
              message: "بازه تاریخ ورود و خروج نباید بیشتر از 20 روز باشد",
            },
          ]);

          valid = false;
        }

        return valid;
      },

      // search hotel
      searchHotel() {
        let destination = this.$refs.destination;

        let nationalityCode =
          this.destinationType === 2
            ? "Ir"
            : this.$refs.nationality.nationalityCode;

        let entryDate = moment(this.$refs.entryDate.date, "jYYYY/jMM/jDD")
          .locale("en")
          .format("YYYY/MM/DD");

        let exitDate = moment(this.$refs.exitDate.date, "jYYYY/jMM/jDD")
          .locale("en")
          .format("YYYY/MM/DD");

        let travellers = this.$refs.travellers;

        let adultsString = "";
        let childString = "";
        let childAgeString = "";
        let roomsCount = 1;

        if (this.destinationType === 1) {
          travellers.rooms.forEach((room) => {
            adultsString += `&a=${room.adults}`;

            childString += `&c=${room.childs.length}`;

            room.childs.forEach((child) => {
              childAgeString += `&g=${Number(child.value)}`;
            });
          });
          roomsCount = travellers.roomsCount;
        } else {
          adultsString += "&a=1";

          childString += "&c=0";
        }

        let url = this.baseUrl;

        let valid = this.checkValidation();

        if (!valid) {
          return;
        }

        if (destination.hotel.locationType === 1) {
          url += `${destination.hotel.countrySlug}/${destination.hotel.citySlug}`;
        } else if (destination.hotel.locationType === 2) {
          url += `${destination.hotel.countrySlug}/${destination.hotel.citySlug}/${destination.hotel.slug}`;
        }

        url += `/?i=${entryDate}&o=${exitDate}&r=${roomsCount}&n=${nationalityCode}&d=${destination.hotel.id}&lt=${destination.hotel.locationType}&dt=${destination.hotel.destinationType}${adultsString}${childString}${childAgeString}`;

        window.location.assign(url);
      },
    },

    created() {
      this.isLoaded = true;
    },
  });
}

//events for buttons that are out side of vue hotel components
const internalHotelEl = document.getElementById("js-btn-hotel-internal");
const externalHotelEl = document.getElementById("js-btn-hotel-external");

if (internalHotelEl && externalHotelEl) {
  internalHotelEl.onclick = function() {
    vmHotel.changeDestinationType(2);
  };

  externalHotelEl.onclick = function() {
    vmHotel.changeDestinationType(1);
  };
}
